import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { GECKO_CONSTS } from 'ui';
import GeckoDate from 'services/gecko-date';

import './index.scss';

class ContactCompare extends Component {
  static propTypes = {
    contact1: PropTypes.object,
    contact2: PropTypes.object,
  };

  iconKeyMap = {
    full_name: 'far fa-user',
    first_name: 'far fa-user',
    last_name: 'far fa-user',
    email: 'far fa-envelope',
    tel: 'far fa-phone',
  };

  iconTypeMap = {
    [GECKO_CONSTS.FIELD_TYPE_ADDRESS]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_DATE]: 'far fa-calendar-alt',
    [GECKO_CONSTS.FIELD_TYPE_EMAIL]: 'far fa-envelope',
    [GECKO_CONSTS.FIELD_TYPE_NAME]: 'far fa-user',
    [GECKO_CONSTS.FIELD_TYPE_NUMBER]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_SELECT]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_SELECT_MULTI]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_CUSTOM]: 'far fa-phone',
    [GECKO_CONSTS.FIELD_TYPE_TELEPHONE]: 'far fa-phone',
    display: 'far fa-align-left',
    [GECKO_CONSTS.FIELD_TYPE_TEXT]: 'far fa-info',
    [GECKO_CONSTS.FIELD_TYPE_TEXTAREA]: 'far fa-info',
  };

  getFieldsToShow() {
    const fieldsToShowForContact1 = this.props.fields.filter((field) => {
      return !!this.getValue(this.props.contact1, field);
    });
    const fieldsToShowForContact2 = this.props.fields.filter((field) => {
      return !!this.getValue(this.props.contact2, field);
    });
    return []
      .concat(fieldsToShowForContact1, fieldsToShowForContact2)
      .filter((field, index, fields) => {
        return fields.findIndex((field2) => field.id === field2.id) === index;
      })
      .sort((f1, f2) => f1.order - f2.order);
  }

  getValue(contact, field) {
    return field.custom_field
      ? contact.custom_fields[field.id]
      : contact[field.key];
  }

  getPrettyValue(value, field) {
    if (!value) {
      return value;
    }
    if (field.type === 'select') {
      return field.field_options.find((opt) => opt.id === value).label;
    }
    if (field.type === 'select_multi') {
      return value
        .map((val) => {
          return field.field_options.find((opt) => opt.id === val).label;
        })
        .join(', ');
    }
    if (field.type === 'date') {
      return new GeckoDate(value, 'X').toString();
    }
    return value;
  }

  getMerge() {
    return this.props.fields.reduce((merge, field) => {
      const cont1Val = this.getValue(this.props.contact1, field);
      const cont2Val = this.getValue(this.props.contact2, field);
      if (field.custom_field) {
        const custom_fields = Object.assign({}, merge.custom_fields || {}, {
          [field.id]: cont1Val || cont2Val,
        });
        return Object.assign({}, merge, { custom_fields });
      }
      return Object.assign({}, merge, { [field.key]: cont1Val || cont2Val });
    }, {});
  }

  renderContact(contact, mergeValues) {
    const fields = this.getFieldsToShow();
    const styles = {
      valueKeep: { backgroundColor: 'rgb(239, 245, 231)' },
      valueRemove: { backgroundColor: 'rgb(253, 234, 230)' },
    };
    return (
      <div className="ContactCompare-contact">
        <div className="ContactCompare-contact-title">{contact.full_name}</div>
        {fields.map((field) => {
          const value = this.getValue(contact, field);
          const mergeValue = this.getValue(mergeValues, field);
          const willKeep = value === mergeValue;
          const icon =
            this.iconKeyMap[field.key] ||
            this.iconTypeMap[field.type] ||
            'far fa-info';
          return (
            <div
              className={`ContactCompare-contact-field ContactCompare-contact-field-${field.type}`}
              style={willKeep ? styles.valueKeep : styles.valueRemove}
            >
              <label>
                <i className={icon}></i>
                {field.label}:
              </label>
              &nbsp;<span>{this.getPrettyValue(value, field)}</span>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const mergeValues = this.getMerge();
    return (
      <div className="ContactCompare">
        {this.renderContact(this.props.contact1, mergeValues)}
        {this.renderContact(this.props.contact2, mergeValues)}
        <div className="ContactCompare-seperator">
          <i className="far fa-arrow-right"></i>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fields: state.fields,
  };
};

export default connect(mapStateToProps)(ContactCompare);
